module.exports = "select{width:100%}\n"